  <template>
  <va-card title="Rules">
    <template slot="actions">
      <va-button @click="addNew"> Add new </va-button>
    </template>

    <!-- I don't think we need this functionality? -->
    <!-- <div class="row align--center mb-1">
      <div class="flex xs12 sm6">
        <va-input
          class="ma-0"
          :value="searchTerm"
          :placeholder="$t('tables.searchByName')"
          @input="search"
        >
          <va-icon name="fa fa-search" slot="prepend" />
        </va-input>
      </div>
    </div> -->

    <div v-if="loading" class="hiq-spinner-div">
      <img class="hiq-spinner" src="/assets/rpspinnerb.png" />
    </div>
    <va-data-table ref="datatable" :fields="fields" :data="filteredData" :allowSelect="false" no-pagination no-data-label="No rules" ext-link-field="__slot:extlink" v-if="!loading">
      <template slot="alerttype" slot-scope="{ rowData }">{{ prettyAlertType(rowData) }}</template>

      <template slot="sitename" slot-scope="{ rowData }">{{ prettySiteName(rowData) }}</template>

      <template slot="actions" slot-scope="props">
        <va-popover :message="`${$t('tables.edit')} rule`" placement="left">
          <va-button flat small color="gray" icon="fa fa-pencil" @click="dialogEdit(props.rowData)" />
        </va-popover>

        <va-popover :message="`${$t('tables.delete')} rule`" placement="left">
          <va-button flat small color="gray" icon="fa fa-trash" @click="dialogTrash(props.rowData)" />
        </va-popover>
      </template>
    </va-data-table>

    <va-modal v-model="showEditDialog" :noOutsideDismiss="true" :hideDefaultActions="true" title="Edit rule">
      <form>
        <div class="row">
          <div class="flex xs12 mb-6">Rules describe the criteria for when to generate an alert.<br><br></div>
        </div>
        <div class="row">
          <div class="flex xs7">
            <va-select label="Type" v-model="dialogTypeVal" :options="dialogTypeOptions" :clearValue="dialogTypeOptions[0]" :noClear="true" :clearOnMount="false" />
          </div>

          <va-button @click="showTypeHelp = !showTypeHelp">?</va-button>

          <va-modal v-model="showTypeHelp" title :hideDefaultActions="true">
            <table>
              <tr>
                <td class="type-help-item">Gateway not reporting</td>
                <td class="type-help-text">A gateway has not been seen for more than 60 minutes.</td>
              </tr>
              <tr>
                <td class="type-help-item">Inverter not reporting</td>
                <td class="type-help-text">An inverter configured on a gateway is not responding to the gateway.</td>
              </tr>
              <tr>
                <td class="type-help-item">Inverter not producing</td>
                <td class="type-help-text">The average output over the past 24 hours is less than 10 watts.</td>
              </tr>
              <tr>
                <td colspan="2" style="text-align: center">
                  <va-button @click="showTypeHelp = false">Close</va-button>
                </td>
              </tr>
            </table>
          </va-modal>
        </div>
        <div class="row">
          <div class="flex xs7">
            <va-select label="Site" v-model="dialogSiteVal" :options="dialogSiteOptions" :clearValue="dialogSiteOptions[0]" :noClear="true" :clearOnMount="false" />
          </div>
        </div>
        <!-- <div class="row">
          <div class="flex xs3">
            <va-input label="Occurrences" v-model="dialogOccurVal" :error="dialogOccurError"></va-input>
          </div>
          <div class="flex xs1"></div>
          <div class="flex xs3">
            <va-input label="Minutes" v-model="dialogDurationVal" :error="dialogDurationError"></va-input>
          </div>
        </div> -->
        <div class="row">
          <div class="flex xs12">
            <va-input v-model="dialogEmailVal1" type="email" style="margin-bottom: 2px;" label="Notification Emails (optional, one per line)"></va-input>
            <va-input v-model="dialogEmailVal2" type="email" style="margin-bottom: 2px;"></va-input>
            <va-input v-model="dialogEmailVal3" type="email" style="margin-bottom: 2px;"></va-input>
            <va-input v-model="dialogEmailVal4" type="email" style="margin-bottom: 2px;"></va-input>
            <va-input v-model="dialogEmailVal5" type="email" style="margin-bottom: 2px;"></va-input>
          </div>
        </div>
      </form>

      <template slot="actions">
        <va-button @click="dialogRuleSave">Save</va-button>
        <va-button @click="dialogRuleCancel">Cancel</va-button>
      </template>
      <span v-if="showSaving">Saving...</span>
      <span style="color: red">{{ errorSaving }}</span>
    </va-modal>

    <va-modal v-model="showConfirmModal" :noOutsideDismiss="true" :hideDefaultActions="true" title="Edit rule">
      <p>Are you sure you want to delete this rule?</p>

      <template slot="actions">
        <va-button @click="confirmDelete">Delete</va-button>
        <va-button @click="cancelDelete">Cancel</va-button>
      </template>
    </va-modal>
  </va-card>
</template>

<script>
import { debounce } from 'lodash'
import hiqapi from '@/hiqapi/hiqapi'

export default {
  // props: ['location'],
  data() {
    return {
      // siteData: [{ 'name': 'Loading...' }],
      location: '',
      loading: true,
      searchTerm: null,
      bFilterIssues: 0,
      listData: [], // list of currentListType
      currentListType: null, // type of list loaded: 'sites', 'gws',   'invs'
      currentListId: -1, // id of list parent:    null,   siteId,  gwSerial  // -1 means none loaded
      currentSelId: null,

      showEditDialog: false,
      dialogRuleId: null, // null for a new rule, the rule id otherwise
      dialogTypeVal: null,
      dialogSiteVal: null,
      dialogEmailVal1: '',
      dialogEmailVal2: '',
      dialogEmailVal3: '',
      dialogEmailVal4: '',
      dialogEmailVal5: '',
      showConfirmModal: false,
      showSaving: false,
      errorSaving: '',
      showTypeHelp: false,

      siteList: [], // siteList[site.id] = name
      // dialogOccurVal: 3,
      // dialogOccurError: false,
      // dialogDurationVal: 60,
      // dialogDurationError: false,
    }
  },
  computed: {
    fields() {
      return [
        { name: '__slot:alerttype', sortField: 'alert_type', title: 'Type', dataClass: 'text-left' },
        { name: '__slot:sitename', sortField: 'site_name', title: 'Site', dataClass: 'text-left' },
        { name: 'notification_email', sortField: 'notification_email', title: 'Notification emails', dataClass: 'text-left' },
        { name: '__slot:actions', dataClass: 'text-right' },
      ]
    },
    dialogTypeOptions() {
      return [
        { id: 'gw-offline', text: 'Gateway not reporting' },
        { id: 'inv-offline', text: 'Inverter not reporting' },
        { id: 'inv-low-production', text: 'Inverter low production' },
      ]
    },
    dialogSiteOptions() {
      return this.siteList
    },

    filteredData() {
      let data = this.listData

      if (!this.searchTerm || this.searchTerm.length < 1) {
        return data
      }

      // If we wanted to search on alert_type, we cannot do it this way because the "pretty" alert type
      // is not in the item data (it comes from prettyAlertType())
      return data
      // return data.filter(item => {
      //   return item.alert_type.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1
      // })
    },
  },

  methods: {
    prettyAlertType(rowData) {
      switch (rowData.alert_type) {
        case 'gw-offline':
          return 'Gateway not reporting'
        case 'inv-offline':
          return 'Inverter not reporting'
      }
      return rowData.alert_type
    },

    prettySiteName(rowData) {
      if (rowData.site_name) {
        return rowData.site_name
      }
      return '(All)'
    },

    async dialogRuleSave() {
      this.showSaving = true

      let emails = this.dialogEmailVal1
      if (this.dialogEmailVal2) {
        emails += ', ' + this.dialogEmailVal2
      }
      if (this.dialogEmailVal3) {
        emails += ', ' + this.dialogEmailVal3
      }
      if (this.dialogEmailVal4) {
        emails += ', ' + this.dialogEmailVal4
      }
      if (this.dialogEmailVal5) {
        emails += ', ' + this.dialogEmailVal5
      }
      console.log('SAVE ', this.dialogRuleId, this.dialogTypeVal.id, emails)

      let data = { alert_type: this.dialogTypeVal.id, site_id: this.dialogSiteVal.id, priority: 0, notification_email: emails }

      let method = 'post'
      let url = '/alert_rules'

      if (this.dialogRuleId) {
        method = 'put'
        url += '/' + this.dialogRuleId
      }
      let resp = await hiqapi.postPutWait(method, url, data)

      this.showSaving = false

      if (resp.status >= 400) {
        this.errorSaving = resp.data.message
      } else {
        this.showToast('Rule saved.', {
          position: 'top-right',
        })

        this.showEditDialog = false
        this.reload()
      }
    },

    dialogRuleCancel() {
      console.log('CANCEL')
      this.showEditDialog = false
    },

    addNew() {
      if (this.showEditDialog) {
        return
      }
      console.log('ADD')
      this.dialogTypeVal = this.dialogTypeOptions[0]
      this.dialogSiteVal = this.dialogSiteOptions[0]
      this.dialogRuleId = null
      this.dialogEmailVal1 = ''
      this.dialogEmailVal2 = ''
      this.dialogEmailVal3 = ''
      this.dialogEmailVal4 = ''
      this.dialogEmailVal5 = ''
      this.showSaving = false
      this.errorSaving = ''
      this.showEditDialog = true
    },

    dialogEdit(item) {
      if (this.showEditDialog) {
        return
      }
      console.log('EDIT', item)
      this.showEditDialog = true

      // Find the correct dialogTypeOption

      for (let dto of this.dialogTypeOptions) {
        if (dto.id === item.alert_type) {
          this.dialogTypeVal = dto
          break
        }
      }
      if (!this.dialogTypeVal) {
        this.dialogTypeVal = this.dialogTypeOptions[0]
      }

      // Find the correct dialogSiteOption

      for (let dso of this.dialogSiteOptions) {
        // console.log(' checking ', dso.id, ' == ', item.site_id)
        if (dso.id === item.site_id) {
          this.dialogSiteVal = dso
          console.log('  YES!')
          break
        }
      }
      if (!this.dialogSiteVal) {
        this.dialogSiteVal = this.dialogSiteOptions[0]
      }

      this.dialogRuleId = item.id

      this.dialogEmailVal1 = ''
      this.dialogEmailVal2 = ''
      this.dialogEmailVal3 = ''
      this.dialogEmailVal4 = ''
      this.dialogEmailVal5 = ''
      let emailList = item.notification_email.split(',')
      if (emailList.length > 0) {
        this.dialogEmailVal1 = emailList[0].trim()
      }
      if (emailList.length > 1) {
        this.dialogEmailVal2 = emailList[1].trim()
      }
      if (emailList.length > 2) {
        this.dialogEmailVal3 = emailList[2].trim()
      }
      if (emailList.length > 3) {
        this.dialogEmailVal4 = emailList[3].trim()
      }
      if (emailList.length > 4) {
        this.dialogEmailVal5 = emailList[4].trim()
      }

      this.showSaving = false
      this.errorSaving = ''

      console.log('ZZZ ', this.dialogTypeVal, this.dialogSiteVal)
    },

    dialogTrash(item) {
      console.log('TRASH', item.id)
      this.itemToDeleteId = item.id
      this.showConfirmModal = true
    },

    async confirmDelete() {
      console.log('YES, DELETE', this.itemToDeleteId)
      await hiqapi.postPutWait('delete', '/alert_rules/' + this.itemToDeleteId)
      this.showConfirmModal = false
      this.reload()
    },

    cancelDelete() {
      console.log('NO DELETE')
      this.showConfirmModal = false
    },

    rowClicked(item) {
      console.log('**************************************** RULES CLICK ON ', item)
    },
    rowDoubleClicked(item) {
      console.log('**************************************** RULES DBL CLICK ON ', item)
    },

    setData(newval) {
      this.loading = false
      this.listData = newval.items

      console.log('RULES SET DATA: ', newval)
    },
    setSiteData(newval) {
      this.siteList = [{ id: 'null', text: '(All sites)' }]
      if (!newval) {
        return
      }
      newval.items.forEach((item) => this.siteList.push({ id: '' + item.id, text: item.name }))

      this.siteList.sort((a, b) => (a.text > b.text ? 1 : b.text > a.text ? -1 : 0))
      console.log('SITE DATA', newval, this.siteList)
    },

    search: debounce(function(searchTerm) {
      this.searchTerm = searchTerm
    }, 400),

    reload() {
      this.isLoading = true
      hiqapi.getcb('/alert_rules', this.setData)
      hiqapi.getcb('/sites', this.setSiteData)
    },
  },

  mounted() {
    // console.log('mounted ----------------------------------')
    // get list of sites for searching
    // hiqapi.getcb("/sites?customer_id=2", this.setData)
    // this.siteData = []
    this.reload()
    // console.log("============================= ", this.$refs.datatable)
    // this.$refs.datatable.selectRow(location.selectedId)
  },
}
</script>

<style lang="scss">
.font-awesome-icon {
  color: #bebebe;
}
.hiq-spinner-div {
  display: flex;
  justify-content: center;
  padding: 30px;
}
.hiq-spinner {
  animation-duration: 1.5s;
  animation-timing-function: cubic-bezier(0.54, 0.18, 0.46, 0.82);
  animation-delay: 0s;
  animation-iteration-count: infinite;
  animation-direction: normal;
  animation-fill-mode: none;
  animation-play-state: running;
  animation-name: spinner-rotation;
}
@keyframes spinner-rotation {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(359deg);
  }
}
.extlink {
  color: #7596fb;
}
.extlink:hover {
  color: #0c30d3;
}
.type-help-text {
  padding-bottom: 10px;
}
.type-help-item {
  font-style: italic;
  padding-right: 20px;
  padding-bottom: 10px;
  white-space: nowrap;
}
</style>
